/**
 * Permissões do módulo de Relatórios.
 *
 * Ficam num arquivo próprio, e não em `reportQueries`, porque o router e a navbar precisam
 * delas para decidir o que renderizar: importar do barrel arrastaria as queries e mutations
 * para dentro do bundle inicial, desfazendo o lazy load das páginas de relatório.
 */

/**
 * Permissão que dá acesso à rota admin (todas as empresas). Sem ela, cai na rota tenant,
 * que filtra pela company do token.
 */
const REPORT_ADMIN_PERMISSION = "report:admin:read:all";

/** Permissão mínima para enxergar os relatórios, em qualquer uma das duas rotas. */
const REPORT_READ_PERMISSIONS = ["report:read:all", REPORT_ADMIN_PERMISSION];

const canReadReports = (permissions: string[]) =>
  REPORT_READ_PERMISSIONS.some((permission) => permissions.includes(permission));

export { canReadReports, REPORT_ADMIN_PERMISSION, REPORT_READ_PERMISSIONS };
